<template>
    <div
        v-if="getIsOpenSidebarSettings"
        class="sidebar-settings"
    >
        <div class="sidebar-settings--overlay" @click="toggleSidebarSettings"></div>

        <div class="sidebar-settings--container p-3">
            <div class="sidebar-settings--header mb-3 w-100">
                <span 
                    class="sidebar-settings--button-close"
                    @click="toggleSidebarSettings"
                >
                    <i class="fal fa-times"></i>
                </span>
            </div>

            <div class="sidebar-settings--footer">
                <component
                    :activeChild="activeSettingsChildIndex"
                    :is="currentConfigurationComponent"
                    :item="activeItemSettings"
                    @saveItemChanges="handleSaveItemChanges"
                    @saveChildItemChanges="handleSaveChildItemChanges"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import SettingsFrameContainer from '../molecules/SettingsFrameContainer.vue';
import SettingsFrameImage from '../molecules/SettingsFrameImage.vue';
import SettingsFrameText from '../molecules/SettingsFrameText.vue';
import SettingsFrameTitle from '../molecules/SettingsFrameTitle.vue';
import SettingsFrameGallery from '../molecules/SettingsFrameGallery.vue';
import SettingsFrameButton from '../molecules/SettingsFrameButton.vue';
import SettingsFrameBeforeAfterImage from '../molecules/SettingsFrameBeforeAfterImage.vue';
import SettingsFrameDefault from '../molecules/SettingsFrameDefault.vue';

export default {
    name: 'SidebarSettings',
    props: {
        id: {
            type: String,
            default: 'sidebarSettings',
        },
        configsReference: {
            type: String | null,
            required: true,
        },
        activeItem: {
            type: Object | null,
            required: true,
        },
        indexItem: {
            type: Number | null,
            required: true,
        },
        indexPageFrame: {
            type: Number | null,
            required: true,
        },
        indexChild: {
            type: Number | null,
            required: false,
            default: null,
        },
    },
    components: {
        SettingsFrameContainer,
        SettingsFrameImage,
        SettingsFrameText,
        SettingsFrameTitle,
        SettingsFrameGallery,
        SettingsFrameButton,
        SettingsFrameBeforeAfterImage,
        SettingsFrameDefault
    },
    data() {
        return {
            shouldShowSidebar: true,
            activeItemSettings: {},
            activeSettingsItemIndex: null,
            activeSettingsPageFrame: null,
            activeSettingsChildIndex: null,
        };
    },
    methods: {
        handleSaveChildItemChanges(child, childIndex) {
            this.$store.dispatch("dashboardModule/UPDATE_CHILD", [
                this.activeSettingsPageFrame, // section - index
                this.activeSettingsItemIndex, // parent - index
                childIndex, // child - index
                child, // child item updated
            ]);
        },
        handleSaveItemChanges(item) {
            this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
                this.activeSettingsPageFrame,
                this.activeSettingsItemIndex,
                item,
            ]);

            this.$emit("updateItemActive", item);
        },
        toggleSidebarSettings() {
            this.$store.dispatch("dashboardModule/TOGGLE_SIDEBAR_SETTINGS");
        },
    },
    computed: {
        ...mapGetters("dashboardModule", [
            "getIsOpenSidebarSettings",
        ]),
        currentConfigurationComponent() {
            switch (this.configsReference) {
                case 'container':
                    return 'SettingsFrameContainer';
                
                case 'image':
                    return 'SettingsFrameImage';

                case 'title':
                    return 'SettingsFrameTitle';

                case 'text':
                    return 'SettingsFrameText';

                case 'gallery':
                    return 'SettingsFrameGallery';

                case 'button':
                    return 'SettingsFrameButton';

                case 'beforeAfterImage':
                    return 'SettingsFrameBeforeAfterImage'
                    
                default:
                    return 'SettingsFrameDefault';
            }
        },
    },
    watch: {
        activeItem: {
            handler: function (val, oldVal) {
                this.activeItemSettings = val;
            },
            deep: true,
        },
        indexItem: {
            handler: function (val, oldVal) {
                this.activeSettingsItemIndex = val;
            },
            deep: true,
        },
        indexPageFrame: {
            handler: function (val, oldVal) {
                this.activeSettingsPageFrame = val;
            },
            deep: true,
        },
        indexChild: {
            handler: function (val, oldVal) {
                this.activeSettingsChildIndex = val;
            },
            deep: true,
        },
    },
    created() {
        this.activeItemSettings = this.activeItem;
        this.activeSettingsItemIndex = this.indexItem;
        this.activeSettingsPageFrame = this.indexPageFrame;
        this.activeSettingsChildIndex = this.indexChild;
    },
};
</script>

<style scoped>
.sidebar-settings {
    display: flex;
    width: 375px;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
}

.sidebar-settings--overlay {
    top: 0;
    left: 0;
    bottom: 0;
    width: calc(100% - 375px);
    z-index: 999;
    position: fixed;
    background: transparent;
}

.sidebar-settings--button-close {
    font-size: 1.4rem;
    cursor: pointer;
    color: var(--main-color);
}

.sidebar-settings--container {
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/SidebarSettings.vue